class WebinarView {
  quoteArr = [
    [`I miss signing into your classes right about now.`, `Michael Hassid`],
    [
      `I just wanted to tell you that I really enjoyed the session about Bach and learned a lot about someone and something that I had zero knowledge about. Yesterday I listened a bit to 'the best pieces of Bach' - really impressive music. Thanks.`,
      `Akiva Kraines`,
    ],
    [
      `I must say I never really connected to Beethoven's 8th sonata but hearing Rubinstein play it, as well as having shared it with you and everyone the other night, it has switched something in me and now I am so deeply moved by it.`,
      `Gershi`,
    ],
    [
      `It was beautiful as always. It is such a mechayae to break out of my day for a few minutes to listen to music - and to have a guided tour of how to listen.`,
      `Akiva Kraines`,
    ],
  ];
  counter = [0];
  overallCounter = [0];
  quoteTextEl = document.querySelector(
    ".section-webinars .container-quote-text .title-third"
  );
  // entryPage = document.querySelector(".section-webinars .grid-i");

  // displayEntryPage() {
  //   if (!this.entryPage) return;

  //   setTimeout(() => {
  //     this.entryPage.classList.add("fade-out");
  //   }, 2000);
  //   setTimeout(() => {
  //     this.entryPage.style.display = "none";
  //   }, 3000);
  // }

  displayQuotes() {
    setTimeout(() => {
      let intervalId = setInterval(() => {
        if (!intervalId) return;
        this.quoteTextEl.innerHTML = "";
        let html = `
        <q class="quote-text"
              >${this.quoteArr[this.counter[0]][0]}
            </q>
             <p class="quoted-by">${this.quoteArr[this.counter[0]][1]}</p>
        `;

        this.quoteTextEl.insertAdjacentHTML("afterbegin", html);

        setTimeout(() => {
          this.quoteTextEl.querySelector(".quote-text").style.opacity = "1";
          this.quoteTextEl.querySelector(".quoted-by").style.opacity = "1";
        }, 20);

        this.counter[0] = this.counter[0] + 1;
        this.overallCounter[0] = this.overallCounter[0] + 1;

        if (this.counter[0] > 3) this.counter[0] = 0;
        if (this.overallCounter[0] > 20) clearInterval(intervalId);
      }, "5000");
    }, 5000);
  }
}

export default new WebinarView();
